import { CollectionHelper } from '@barthauer/abc/core';
import { Coordinate, Geometry, Line, Point, Polygon } from '../basys-map-frame.module';

export class ViewModelHelper {
  //https://medium.com/@jakubsynowiec/unique-array-values-in-javascript-7c932682766c
  public static flattenAndDistinctToArray(data: object[]): string[] {
    const result: string[] = [];

    const seen: Set<string> = new Set<string>();
    for (let i = 0; i < data.length; i++) {
      const objValues = Object.values(data[i]);
      //const objValues = data[i].getValues();

      for (let a = 0; a < objValues.length; a++) {
        let prop = objValues[a];
        if (prop && !seen.has(prop)) {
          prop = prop.toString();
          seen.add(prop);
          result.push(prop);
        }
      }
    }
    return result;
  }

  public static distinctToArray(data: object): string[] {
    const result: string[] = [];
    const objValues = Object.values(data);
    for (let a = 0; a < objValues.length; a++) {
      if (objValues[a]) {
        CollectionHelper.safePushValueToArray<string>(result, objValues[a].toString());
      }
    }
    return result;
  }
}

export class GeometryHelper {
  public static formPolygonGeometries(polygon: any, identifier: string): any {
    const coordinates = polygon.getCoordinates();
    const exteriorpoints = [];
    if (coordinates.length) {
      for (let c of coordinates[0]) {
        exteriorpoints.push({ x: c[0], y: c[1] });
      }
    }

    return {
      Polygons: [
        {
          identifier: identifier,
          Feature: {
            ExteriorRing: {
              Points: exteriorpoints,
            },
          },
        },
      ],
    };
  }

  public static formLineGeometries(line: any, identifier: string): any {
    const coordinates = line.getCoordinates();
    const points = [];
    for (let c of coordinates) points.push({ x: c[0], y: c[1] });

    return {
      Lines: [
        {
          identifier: identifier,
          Feature: {
            Points: points,
          },
        },
      ],
    };
  }

  public static formPointGeometries(point: any, identifier: string, z: any): any {
    let coor = point.flatCoordinates;
    let ret = {
      Points: [
        {
          identifier: identifier,
          Feature: {
            Coordinate: {
              x: coor[0],
              y: coor[1],
              z: z,
            },
          },
        },
      ],
    };

    return ret;
  }

  public static deletePointGeometries(geometry: Geometry) {
    if (geometry) {
      geometry.Points = [];
    }
  }
  public static deleteLineGeometries(geometry: Geometry) {
    if (geometry) {
      geometry.Lines = [];
    }
  }
  public static deletePolygonGeometries(geometry: Geometry) {
    if (geometry) {
      geometry.Polygons = [];
    }
  }

  public static addPointToGeometry(geometry: Geometry, identifier: string, x: number, y: number, z?: number) {
    const point: Point = {
      identifier: identifier,
      Feature: {
        Coordinate: {
          x: x,
          y: y,
          z: z,
        },
      },
    };

    if (geometry) {
      if (!geometry.Points) {
        geometry.Points = [];
      }

      geometry.Points.push(point);
    }
  }

  public static addLineToGeometry(geometry: Geometry, identifier: string, lineFeature: any) {
    const coordinates = lineFeature.getCoordinates();
    const points: Coordinate[] = coordinates.map((c: number[]) => ({ x: c[0], y: c[1] }));

    const line: Line = {
      identifier: identifier,
      Feature: { Points: points },
    };

    if (geometry) {
      if (!geometry.Lines) {
        geometry.Lines = [];
      }
      geometry.Lines.push(line);
    }
  }

  public static addPolygonToGeometry(geometry: Geometry, identifier: string, polygonFeature: any) {
    const coordinates = polygonFeature.getCoordinates();
    const exteriorpoints = [];
    if (coordinates.length) {
      for (let c of coordinates[0]) {
        exteriorpoints.push({ x: c[0], y: c[1] });
      }
    }

    const polygon: Polygon = {
      identifier: identifier,
      Feature: {
        ExteriorRing: { Points: exteriorpoints },
      },
    };

    if (geometry) {
      if (!geometry.Polygons) {
        geometry.Polygons = [];
      }
      geometry.Polygons.push(polygon);
    }
  }
}
